<template>
    <CRow class="mx-1">
      <CCol col="12">
        <CDataTable
          :items="items"
          :fields="fields"
          responsive
          sorter
          column-filter
          hover
          show-empty
          :loading="loading"
          @update:column-filter-value="onFilter($event)"
        >
          <template #Actions="{ item }">
            <td>
              <b-button
                variant="warning"
                class="mr-1"
                v-c-tooltip.hover.click="'Edit Data'"
                @click="editData(item)"
                :disabled="$store.state.role_aktif.kodeRole != 'super' && !item.mitraId"
                ><CIcon name="cil-pencil" />{{ item.actions }}</b-button
              >
              <!-- <b-button
                variant="info"
                class="mr-1"
                v-c-tooltip.hover.click="'Detail'"
                v-b-modal.modal-detail
                @click="(data = item), (detail = !detail)"
                :disabled="$store.state.role_aktif.kodeRole != 'super' && !item.mitraId"
                ><CIcon name="cil-info" />{{ item.actions }}</b-button
              > -->
            </td>
          </template>
        </CDataTable>
        <MyPagination :entriesaw="entriesaw" :entriesak="entriesak" :totalRows="totalRows" :currentPage="currentPage" :perPage="perPage" @changeVar="changeVar" />
      </CCol>
    </CRow>
</template>

<script>

export default {
  components: {
  },
  name: "asuransi",
  data() {
    return {
      detail: false,
      data: {},
      items: [],
      fields: [
        {
          key: "no",
          label: "No",
          sortDirection: "desc",
          class: "table-number text-center ",
          _style: "width: 1px;",
          filter: false,
          sorter: false,
        },
        {
          key: "namaKaryawan",
          label: "Nama",
          _style: "max-width: 25%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "alamatKaryawan",
          label: "Alamat",
          _style: "max-width: 40%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "emailKaryawan",
          label: "Email",
          _style: "width: 15%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        // {
        //   key: "namaDivisi",
        //   label: "Divisi",
        //   _style: "width: 10%;",
        //   sortDirection: "desc",
        //   class: "text-left",
        //   sorter: false,
        // },
        {
          key: "namaPosisi",
          label: "Posisi",
          _style: "width: 10%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "Actions",
          label: "Actions",
          _style: "width: 10%;",
          class: "table-option-2 text-center",
          filter: false,
          sorter: false,
        },
      ],
      filter: {
      },
      perPage: 10,
      totalRows: 0,
      currentPage: 1,
      loading: false,
    };
  },
  computed: {
    entriesaw() {
      return this.items.length != 0 && this.items ? this.items[0].no : 0;
    },
    entriesak() {
      return this.items.length != 0 && this.items ? this.items[this.items.length - 1].no : 0;
    },
  },
  mounted() {
    if(this.$store.state.role_aktif.kodeRole == 'super'){
      this.fields.splice(1, 0, { 
        key: "namaMitra",
        label: "Mitra",
        _style: "width: 10%;",
        sortDirection: "desc",
        class: "text-left",
        sorter: false,
      })
    }
    this.getDatas();
  },
  watch: {
    currentPage(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    perPage(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
  },
  methods: {
    onFilter(x) {
      const vm = this;
      vm.filter = {...vm.filter, ...x};
      vm.currentPage = 1;
      vm.getDatas();
    },
    async getDatas() {
      const vm = this;
      vm.loading = true;
      let listBelumDitempatkan = await vm.$axios.post("dataKaryawan/listDataKaryawanBelumDitempatkanPerHalaman", {
        ...vm.filter,
        statusPenempatan: 0,
        halaman: vm.currentPage - 1,
        jumlah: vm.perPage,
      });
      // console.log("listBelumDitempatkan", listBelumDitempatkan);
      vm.items = listBelumDitempatkan.data.status == 200 ? listBelumDitempatkan.data.data.map((x, idx) => { 
        // });
        return {
          ...x,
          no: (vm.currentPage - 1) * vm.perPage + idx + 1,
          id: x.dataKaryawanId, 
          namaMitra: x.namaMitra || ' - ',
          namaDivisi: x.namaDivisi ? x.namaDivisi : ' - ',
        }
      }): [];
      vm.totalRows = Number(listBelumDitempatkan.data.count);
      vm.loading = false;
    },
    editData(data) {
      let vm = this;
      let routeData = vm.$router.resolve({name: 'Detail Karyawan', query: { dataKaryawanId: data.dataKaryawanId }});
      window.open(routeData.href, '_blank');
    },
    triggerAlert(event) {
      let vm = this;
      vm.$store.commit("set_alert", event);
      vm.getDatas();
    },
    changeVar({name, data}){
      this[name] = data
    }
  },
};
</script>
